/** A single organiser note attached to a participant (Notes tab). */
export default class ParticipantNotesDto {
  public static createEmpty(): ParticipantNotesDto {
    return new ParticipantNotesDto();
  }

  constructor(
    public Id: number = 0,
    public EventId: number = 0,
    public ParticipantId: number = 0,
    public InviteeId: number | null = null,
    public Note: string = '',
    public IsDeleted: boolean = false,
    public CreatedOn: Date = new Date(),
    public CreatedBy: string = '',
    public UpdatedOn?: Date,
    public UpdatedBy?: string,
  ) {}
}
